import {
	BigNum,
	convertToNumber,
	PositionDirection,
	QUOTE_PRECISION_EXP,
	TEN_THOUSAND,
} from '@velocity-exchange/sdk';
import { MarketId } from '@velocity-exchange/common';
import { useEffect } from 'react';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';

export const useSyncLeverageAfterTrade = (
	tradeFormSide: 'buy' | 'sell',
	quoteSize: number,
	selectedMarketId: MarketId | undefined
) => {
	const currentUserClient = useVelocityAccountStore(
		(s) => s.getCurrentUserAccount()?.client
	);
	const setState = useVelocityStore((s) => s.set);

	/* Keep leverageAfterTrade intact */
	useEffect(() => {
		try {
			const leverageAfterTrade = (() => {
				if (!currentUserClient || !selectedMarketId) {
					return 0;
				}

				return convertToNumber(
					currentUserClient.accountLeverageRatioAfterTrade(
						selectedMarketId.marketIndex,
						selectedMarketId.marketType,
						BigNum.fromPrint(`${quoteSize}`, QUOTE_PRECISION_EXP).val,
						tradeFormSide === 'buy'
							? PositionDirection.LONG
							: PositionDirection.SHORT
					),
					TEN_THOUSAND
				);
			})();

			setState((s) => {
				s.tradeForm.leverageAfterTrade = leverageAfterTrade;
			});
		} catch (e) {
			console.error(e);
			setState((s) => {
				s.tradeForm.leverageAfterTrade = 0;
			});
		}
	}, [quoteSize, selectedMarketId, currentUserClient, tradeFormSide]);
};
